<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" />
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                        <div :class="{'grey-background': activeButton === button.value, 'font-color-98A2B3': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                            {{ button.label }}
                        </div>
                    </CCol>
    
                </CRow>
            </CCard>
    
            <div v-if="activeButton === 'Leave'">
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <h3 class="custom-18px-500 font-color-171717">Leave Approval</h3>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">First Level Approval</label>
                                <v-select v-model="selectedApprover" :options="approverOptions" label="FullName"></v-select>
                            </CCol>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">Second Level Approval</label>
                                <v-select v-model="selectedApprover2" :options="approverOptions" label="FullName"></v-select>
                            </CCol>
                            <CCol sm="2">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitApprover()">
                                        Save</CButton>
                                </div>
                            </CCol>
                        </CRow>
    
    
                    </div>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="9">
                                <h3 class="custom-18px-500 font-color-171717">Leave Policy</h3>
                            </CCol>
                            <CCol sm="3" class="text-right">
                                <CButton class="btn-border-blue font-color-0B63F6" @click="openPolicy"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Create Leave Policy</CButton>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="6">
                                <CRow>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Annual Leave</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Medical Leave</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Compassionate Leave - Paternity Leave</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Compassionate Leave - Maternity Leave</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Compassionate Leave - Death of Family Member</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Sick (Spouse, Child, Parent)</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Emergency Leave</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="6">
                                <CRow>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Public Holiday</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Leave In Lieu</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Exam Leave</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Special Leave - Marriage Leave</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Special Leave - Umrah Leave
                                                            </label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Special Leave - Hajj Leave/ Others</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Carry Forward Leave</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </div>
                </CCard>
            </div>
    
            <div v-if="activeButton === 'TimeOff'">
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <h3 class="custom-18px-500 font-color-171717">Timeoff Approval</h3>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">First Level Approval</label>
                                <v-select v-model="selectedApproverTimeOff" :options="approverOptions" label="FullName"></v-select>
                            </CCol>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">Second Level Approval</label>
                                <v-select v-model="selectedApprover2TimeOff" :options="approverOptions" label="FullName"></v-select>
                            </CCol>
                            <CCol sm="2">
                                <div class="text-right">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitApproverTimeOff()">
                                        Save</CButton>
                                </div>
                            </CCol>
                        </CRow>
    
    
                    </div>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="9">
                                <h3 class="custom-18px-500 font-color-171717">Timeoff Setting</h3>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Enable Attachment</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="mx-1" variant="3d" color="primary" v-bind="labelIcon" type="checkbox" name="enableAttachment" :checked="EnableAttachment" @update:checked="(val) => {
            EnableAttachment = val;
            radio = val; 
          }" />
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Application Limit Hour</label>
                                    </CCol>
                                    <CCol sm="2">
    
                                        <CSwitch class="mx-1" variant="3d" color="primary" v-bind="labelIcon" type="checkbox" name="applicationLimitHour" :checked="ApplicationLimitHour" @update:checked="(val) => {
            ApplicationLimitHour = val; 
            radio = val; 
          }" /> </CCol>
    
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="6">
                                        <label class="custom-14px-500 font-color-171717">Minimum hour(s)</label>
                                        <v-select v-model="selectedTimeMin" :options="hourOptions" label="Time"></v-select>
                                    </CCol>
                                    <CCol sm="6">
                                        <label class="custom-14px-500 font-color-171717">Maximum hour(s)</label>
                                        <v-select v-model="selectedTimeMax" :options="hourOptions" label="Time"></v-select>
                                    </CCol>
                                    <CCol sm="12">
                                        <div class="text-right mt-3">
                                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitTimeOff()">
                                                Save</CButton>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </div>
                </CCard>
            </div>
    
    
    
        </CCol>
    
        <div v-if="OpenAddLeavePolicy" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create Policy</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Leave Type</h3>
                                        <v-select></v-select>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Display Name</h3>
                                        <v-select></v-select>
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717 mt-4">Group Policy</h3>
                                    </CCol>
    
                                    <CCol sm="12">
                                        <CRow>
                                            <CCol sm="6" class="mt-2">
                                                <CRow class="mt-2">
                                                    <CCol sm="8">
                                                        <h3 class="custom-14px-500 font-color-171717">Board Of Director</h3>
    
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" class="ml-2" />
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <hr class="custom-hr" />
                                                    </CCol>
    
    
                                                    <CCol sm="8">
                                                        <h3 class="custom-14px-500 font-color-171717 mt-2">HOD/Manager
                                                        </h3>
    
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" class="ml-2" />
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <hr class="custom-hr" />
                                                    </CCol>
    
                                                    <CCol sm="8">
                                                        <h3 class="custom-14px-500 font-color-171717 mt-2">Finance/Account</h3>
    
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" class="ml-2" />
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <hr class="custom-hr" />
                                                    </CCol>
    
    
                                                </CRow>
                                            </CCol>
                                            <CCol sm="6" class="mt-2">
                                                <CRow>
                                                    <CCol sm="8">
                                                        <h3 class="custom-14px-500 font-color-171717 mt-2">Human Resource</h3>
    
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" class="ml-2" />
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <hr class="custom-hr" />
                                                    </CCol>
    
                                                    <CCol sm="8">
                                                        <h3 class="custom-14px-500 font-color-171717 mt-2">Employee</h3>
    
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" class="ml-2" />
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <hr class="custom-hr" />
                                                    </CCol>
                                                </CRow>
    
    
                                            </CCol>
                                        </CRow>
    
                                    </CCol>
    
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717 mt-4">Exclude Employee</h3>
                                        <CInput type="text" />
                                        <hr class="custom-hr" />
                                        <CRow class="mt-2">
                                            <CCol sm="6">
                                                <CRow>
                                                    <CCol sm="10">
                                                        <h3 class="custom-14px-500 font-color-171717">Upload Attachment</h3>
    
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <hr class="custom-hr" />
                                                    </CCol>
                                                </CRow>
    
                                            </CCol>
                                            <CCol sm="6">
                                                <CRow>
                                                    <CCol sm="10">
                                                        <h3 class="custom-14px-500 font-color-171717">Reason</h3>
    
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <hr class="custom-hr" />
                                                    </CCol>
                                                </CRow>
                                            </CCol>
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Day Limit</h3>
                                                <v-select></v-select>
    
                                                <h3 class="custom-14px-500 font-color-171717 mt-3">Leave Remarks</h3>
                                                <CInput type="text" />
                                            </CCol>
    
    
    
    
                                        </CRow>
                                    </CCol>
    
                                </CRow>
                            </CCol>
                        </CRow>
    
                        <div class="text-right">
                            <CRow>
                                <CCol sm="6">
                                    <CButton class="custom-grey-radius font-color-171717" @click="closePopup" block>Cancel</CButton>
                                </CCol>
                                <CCol sm="6">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half" block>
                                        Add</CButton>
                                </CCol>
                            </CRow>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
    
    
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'TimeOff', // Default active button
            buttons: [
                { value: 'Leave', label: 'Leave', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'TimeOff', label: 'Time Off', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],

            options: {
                perPage: 5,
                pagination: true,
                searchable: true
            },

            OpenAddLeavePolicy: false,
            isPopupSuccess: false,

            approverOptions: [],
            selectedApprover: {},
            selectedApprover2: {},

            selectedApproverTimeOff: {},
            selectedApprover2TimeOff: {},
            app: [],

            selectedTimeMin: {},
            hourOptions: [],

            selectedTimeMax: {},
            EnableAttachment: false, // Default value for the switch
            ApplicationLimitHour: false, // Default value for the switch

        }
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetListStaffApproval();
                await this.GetListApproverLeave();
                await this.GetListApproverTimeOff();
                await this.GetListHour();
                await this.GetSettingTimeOff();



            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    watch: {
        EnableAttachment(newVal) {
            console.log("EnableAttachment changed to:", newVal);
        },
        ApplicationLimitHour(newVal) {
            console.log("ApplicationLimitHour changed to:", newVal);
        }
    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyDetails() {
            try {
                const response = await this.$API.get(this.$GetCompanyDetails, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.company = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyDetailsByInfo() {
            try {
                const response = await this.$API.get(this.$GetCompanyDetails, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.FullName = this.info.name;
                        this.Address = this.info.Address;
                        this.City = this.info.City;
                        this.CompanyTypeName = this.info.CompanyTypeName;
                        this.Country = this.info.Country;
                        this.Email = this.info.Email;
                        this.Fax = this.info.Fax;
                        this.CompanyIndustryType = this.info.IndustryType;
                        this.LogoPath = this.info.LogoPath;
                        this.PhoneNumber = this.info.PhoneNumber;
                        this.Postcode = this.info.Postcode;
                        this.RegistrationNumber = this.info.RegistrationNumber;
                        this.ShortName = this.info.ShortName;
                        this.State = this.info.State;

                        this.SetupSelectedOption();
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch company information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closePopup() {
            this.OpenAddLeavePolicy = false;
        },
        openPolicy() {
            this.OpenAddLeavePolicy = true;
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        GoToSetting() {
            this.$router.push("Setting");
        },
        async GetListStaffApproval() {
            try {
                const response = await this.$API.get(this.$GetListAllStaffWoPagination, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.approverOptions = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        SubmitApprover() {
            const formData = new FormData();
            formData.append("FirstAppUserId", this.selectedApprover.Id);
            formData.append("SecondAppUserId", this.selectedApprover2.Id);
            formData.append("TypeSettingApprover", 1);

            this.$API
                .post(this.$InsertApprover, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.isPopupSuccess = true;
                        this.GetListApprover();

                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        SubmitApproverTimeOff() {
            const formData = new FormData();
            formData.append("FirstAppUserId", this.selectedApproverTimeOff.Id);
            formData.append("SecondAppUserId", this.selectedApprover2TimeOff.Id);
            formData.append("TypeSettingApprover", 2);

            this.$API
                .post(this.$InsertApprover, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.isPopupSuccess = true;
                        this.GetListApproverTimeOff();

                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess() {
            this.isPopupSuccess = false;
        },
        async GetListApproverLeave() {
            try {
                const response = await this.$API.get(this.$GetListApprover + "?type=1", {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.FirstApprover1 = this.info.firstapp1;
                        this.SecondApprover2 = this.info.secondapp2;
                        this.SetupSelectedOption();
                    }
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListApproverTimeOff() {
            try {
                const response = await this.$API.get(this.$GetListApprover + "?type=2", {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.FirstApprover1TimeOff = this.info.firstapp1;
                        this.SecondApprover2TimeOff = this.info.secondapp2;
                        this.SetupSelectedOption();
                    }
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        
        SetupSelectedOption() {
            this.selectedApprover = _.find(this.approverOptions, { FullName: this.FirstApprover1 });
            this.selectedApprover2 = _.find(this.approverOptions, { FullName: this.SecondApprover2 });

            this.selectedApproverTimeOff = _.find(this.approverOptions, { FullName: this.FirstApprover1TimeOff });
            this.selectedApprover2TimeOff = _.find(this.approverOptions, { FullName: this.SecondApprover2TimeOff });


            this.selectedTimeMin = _.find(this.hourOptions, { Time: this.MinHour });
            this.selectedTimeMax = _.find(this.hourOptions, { Time: this.MaxHour });


            console.log("selectedTimeMin:", this.selectedTimeMin);
        },
        async GetListHour() {
            try {
                const response = await this.$API.get(this.$GetListHour, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.hourOptions = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetSettingTimeOff() {
            try {
                const response = await this.$API.get(this.$GetCompanySettingTimeOff, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.MinHour = this.info.min_hour;
                        this.MaxHour = this.info.max_hour;
                        this.EnableAttachment = this.info.enable_attachment;
                        this.ApplicationLimitHour = this.info.app_limit_hour
                        this.SetupSelectedOption();
                    }
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        SubmitTimeOff() {
            console.log("SubmitTimeOff function called");

            const formData = new FormData();

            formData.append("MinHour", this.selectedTimeMin.Time);
            formData.append("MaxHour", this.selectedTimeMax.Time);
            formData.append("TypeSettingApprover", 2);


            formData.append("EnableAttachment", this.EnableAttachment ? "true" : "false");
            formData.append("AppLimitHour", this.ApplicationLimitHour ? "true" : "false");

            // Log FormData
            for (let pair of formData.entries()) {
                console.log(`${pair[0]}: ${pair[1]}`);
            }

            this.$API
                .post(this.$InsertTimeOffSetting, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    } else if (response.status === 200) {
                        this.isPopupSuccess = true;
                        this.GetSettingTimeOff();
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        updateEnableAttachment(event) {
            this.EnableAttachment = event.target.checked;
            console.log("EnableAttachment toggled to:", this.EnableAttachment);
        },
        updateApplicationLimitHour(event) {
            this.ApplicationLimitHour = event.target.checked;
            console.log("ApplicationLimitHour toggled to:", this.ApplicationLimitHour);
        },





    }

};
</script>